import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { baselinker } from "@/lib/platforms-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/platformy/baselinker";

export const Route = createFileRoute("/platformy/baselinker")({
  head: () =>
    buildSeoMeta({
      title: "Wdrożenia Baselinker — integracje, automatyzacje, ERP | SyncTech",
      description:
        "Wdrożenia i integracje Baselinker dla sklepów e-commerce. Allegro, Amazon, Shopify, Shoper, ShopGold, ERP (Comarch, Subiekt), kurierzy. Automatyzacje, które oszczędzają godziny dziennie.",
      path: PATH,
    }),
  component: () => <PlatformPage data={baselinker} path={PATH} breadcrumbCategory="Platformy" />,
});
